import React from "react";
import { SpacingCustom } from "../../layout/Spacing/SpacingCustom";

interface ISeparatorLineProps {
    paddingTop?: number,
    lineIntensity?: number
}

export const SeparatorLine: React.FC<ISeparatorLineProps> = ({paddingTop = 2, lineIntensity = 0.15}) => {
    return (
        <SpacingCustom paddingTop={paddingTop}>
            <div className="separator" style={{width:'100%', borderBottom:`1px solid rgba(0,0,0,${lineIntensity})`}}></div>
        </SpacingCustom>
    )
}